import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConnectedProps, connect } from "react-redux";
import { Formik } from "formik";
import Common from "us.common";
import {
  $Drawer,
  $Skeleton,
  $Tag,
  $Spin,
  $Empty,
  $Alert,
  $Upload,
  $MessageBox,
  $Divider,
} from "us.common/components";
import { matchPath, useLocation } from "react-router-dom";
import {
  BoxIcons,
  IconTypes,
  FolderOpenFilled,
  FolderFilled,
  FileAddOutlined,
  LoadingOutlined,
  FileExclamationOutlined,
  RightOutlined,
  UploadOutlined,
} from "us.icons";
import { MessageAndNoteAction } from "us.collection.case/actions";
import { IAttachmentFiles } from "us.collection.case/components/Interfaces/NotesAndMessage";
import {
  GetMessageContent,
  PrintedDocumentContent,
  PrintedDocumentsForAttachment,
  UploadDocumentContent,
  UploadDocumentsForAttachment,
} from "us.collection.case/repository";
import {
  getMIMETypeByFileFormat,
  base64toStr,
} from "us.collection.documents/functions";
import {
  DocumentCriteria,
  DomainMessageType,
  FilterDocumentCriteria,
  INVALID_FORMATS,
  SortDocumentCriteria,
} from "us.collection.case/constants/NotesAndMessage";
import { isSubCaseTransferredToCase } from "us.common/functions";
import { appInsights } from "us.helper";
import "../../ContentV2.scss";
import XMLViewer from "react-xml-viewer";
import { setHTMLCode } from "../../Functions";
import { TemplateEditor } from "../TemplateEditor";
import { RootState } from "us.helper/types";
import _ from "lodash";
import { getEntityTypeByKey } from "us.collection.case/functions";
import EmailValidation from "../../Validations/EmailValidation";
import { GetFileUploadRequest } from "us.collection.case/components/Detail/NotesAndMessages/Repository";
import dayjs from "dayjs";
import {
  StorageType,
  UPLOAD_RULES_INITIAL_VALUES,
} from "us.collection.case/components/Detail/NotesAndMessages/Constants";
import { IRootState } from "us.collection/interfaces";
import {
  filterDocumentsByName,
  getModifiedPrintedDocuments,
  orderByCreatedDate,
} from "us.collection.case/functions/Dashboard";
import { PrintedDocuments, UploadedDocuments } from "./Components";
import { getFileNameFromPath } from "us.collection.case/components/Detail/NotesAndMessages/functions";

const { $Form, $Input, $Select, $Button, $DatePicker, $Tooltip, $Row, $Col } =
  Common.Components;

type EmailProps = {
  setNoteView: <T>(data: T) => void;
};

const Email: React.FC<EmailProps & PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const pathname = useLocation().pathname;
  const attachmentFiles: IAttachmentFiles = {
    fileNames: [],
    filePaths: [],
    isSelected: false,
  };
  const [isPrintedDoc, setIsPrintedDoc] = useState<boolean>(true);
  const [fileStatus, setFileStatus] = useState<any>({});
  const [selectAttachment, setSelectAttachment] = useState(attachmentFiles);

  const {
    currentDateFormat,
    domainMessageFormattedTemplate,
    openTemplateDrawer,
    domainMessageBasicdetail,
    metaData,
    domainMessageInitial,
    openAttachmentDrawer,
    printedDocuments,
    uploadedDocuments,
    emailAttachmentContent,
    location,
    sendDomainMessage,
    uploadRules,
    deleteDocument,
    uploadingDocument,
    getMessageContent,
    openDrawer,
    reset,
    send,
    setNoteView,
    showAttachment,
    getPrintedDocument,
    getUploadedDocument,
    getAttachmentContent,
    formattedMessageContentDetails,
    sendDashboardMessage,
    getUploadingRules,
  } = props;

  const { entityType } = metaData.data ?? {};

  const showAttachmentFile = emailAttachmentContent?.data[0];
  const unableToDisplayFormats = INVALID_FORMATS;

  useEffect(() => {
    if (sendDomainMessage?.data?.isSuccess) {
      reset && reset({});
      setSelectAttachment(attachmentFiles);
      setNoteView(DomainMessageType.EMAIL);
    }
  }, [sendDomainMessage?.data?.isSuccess]);

  useEffect(() => {
    if (formattedMessageContentDetails?.data?.messages?.length) {
      if (document.getElementById("editor")) {
        setHTMLCode(formattedMessageContentDetails?.data?.messages[0], "");
      }
    }
  }, [formattedMessageContentDetails.data]);

  const showDrawer = (values:any) => {
    if (metaData.data) {
      // Get printed documents
      const queryParam_ = PrintedDocumentsForAttachment(metaData.data);
      getPrintedDocument && getPrintedDocument({request: queryParam_, formValues: values});

      // Get uploaded documents
      const queryParam = UploadDocumentsForAttachment(metaData.data);
      getUploadedDocument && getUploadedDocument({request: queryParam, formValues: values});
    }
    getUploadingRules && getUploadingRules(UPLOAD_RULES_INITIAL_VALUES);
    openDrawer &&
      openDrawer({
        title: t("US.COLLECTION.CASE:NOTESANDMESSAGES.SELECTATTACHMENT"),
        isSelectAttachment: true,
        visible: true,
      });
  };
  const closeDrawer = () => {
    setSelectAttachment((state) => ({
      ...state,
      isSelected: false,
    }));
    openDrawer &&
      openDrawer({
        title: "",
        isSelectAttachment: false,
        visible: false,
      });
  };

  /**
   * Get formatted template
   * @param values - form values
   */
  const handleTemplateDrawer = (values: any) => {
    try {
      if (metaData.data) {
        const payload = GetMessageContent.call({
          ...values,
          entityType: getEntityTypeByKey(metaData.data.entityType),
          emailOrTelNo: values.emailAddress,
          entityId: metaData.data.caseId,
          messageType: "Email",
        });
        getMessageContent && getMessageContent(payload);
        openDrawer &&
          openDrawer({
            title: t("US.COLLECTION.CASE:NOTESANDMESSAGES.PREVIEW"),
            isTemplateEditor: true,
            visible: true,
          });
      }
    } catch (error) {
      appInsights.trackException(
        `Dashboard NotesAndMessage-Email Drawer Handling Exeception - ${error}`
      );
    }
  };
  /**
   * Close formatted template drawer
   * @param rest - props
   */
  const closeTemplateDrawer = (rest: any) => {
    rest.setFieldValue("dueDate", "");
    openDrawer &&
      openDrawer({
        title: "",
        isTemplateEditor: false,
        visible: false,
      });
  };

  /**
   * Add select attchment to list
   * * @param file - file name
   */
  const handleAttachment = (file: string, filePath: string) => {
    try {
      const tempselectAttachment = [...selectAttachment.fileNames];
      const tempFilePaths = [...selectAttachment.filePaths];
      if (
        !selectAttachment.fileNames?.some((fileName: any) => fileName === file)
      ) {
        tempselectAttachment.push(file);
        tempFilePaths.push({
          fileName: file,
          path: filePath,
        });
        setSelectAttachment({
          fileNames: [...tempselectAttachment],
          filePaths: [...tempFilePaths],
          isSelected: false,
        });
        closeDrawer();
      } else {
        setSelectAttachment({
          fileNames: [...tempselectAttachment],
          filePaths: [...tempFilePaths],
          isSelected: true,
        });
      }
    } catch (error) {
      appInsights.trackException(
        `Dashboard NotesAndMessage-Add Select Attachment to List Exeception - ${error}`
      );
    }
  };

  /**
   * Remove selected attachment
   * @param file - file name
   */
  const removeAttachment = (file: string) => {
    try {
      const tempSelectedData = [...selectAttachment.fileNames];

      if (
        selectAttachment.fileNames.some((fileName: any) => fileName === file)
      ) {
        const index = tempSelectedData.indexOf(file);
        if (index !== -1) tempSelectedData.splice(index, 1);
        const tempFilePaths = selectAttachment.filePaths.filter(
          (item: any) => item.fileName !== file
        );

        setSelectAttachment({
          fileNames: tempSelectedData,
          filePaths: [...tempFilePaths],
          isSelected: false,
        });
      }
    } catch (error) {
      appInsights.trackException(
        `Dashboard NotesAndMessage- Remove Selected Attachment from the List Exeception - ${error}`
      );
    }
  };

  /**
   * Change document type (Debtor,Creditor,Other Parties with name)
   * @param receiver
   * @param rest
   */
  const changeDocumentType = (receiver: string, rest: any) => {
    const entityDetails = domainMessageBasicdetail.entityDetails?.find(
      (entity: any) => entity.receiver === receiver
    );
    rest.setFieldValue("emailAddress", entityDetails?.emailAddress);
    rest.setFieldValue("receiverEntityId", entityDetails?.entityId);
  };

  /**
   * Get select file content
   * @param value - The selected label
   */
  const handleAttachmentFileShow = (value: any) => {
    try {
      let comJobId = 0;
      let documentId = 0;
      let activityName = "";
      printedDocuments?.data?.map((item: any) => {
        if (getFileNameFromPath(item?.outputInfo) === value) {
          comJobId = item.communicationJobId;
          activityName = item.activityName;
        }
      });
      uploadedDocuments?.data?.map((item: any) => {
        if (item.documentName === value) {
          documentId = item.documentId;
        }
      });
      const { params }: any = matchPath( {
        path: "/:caseType/:caseId",
        end: true,
        caseSensitive: false,
      },pathname);
      const caseType = params["caseType"];
      let queryParamObject = {};
      // Printed document content
      if (entityType) {
        if (comJobId > 0) {
          queryParamObject = PrintedDocumentContent.call(
            {
              activityName,
              comJobId,
              caseType,
            },
            entityType
          );
        } else {
          // Uploaded document content
          queryParamObject = UploadDocumentContent.call(
            {
              documentId,
              caseType,
            },
            entityType
          );
        }
      }
      getAttachmentContent && getAttachmentContent(queryParamObject);
      showAttachment && showAttachment({ title: value, visible: true });
    } catch (error) {
      appInsights.trackException(
        `Dashboard NotesAndMessage- Get select file content Exeception - ${error}`
      );
    }
  };

  const closeAttachmentFileShow = () => {
    showAttachment && showAttachment({ title: "", visible: false });
  };

  const tagRender = (props: any) => {
    const { label, value, closable, onClose } = props;
    return (
      <$Tooltip placement="topLeft" title={label}>
        <$Tag
          onClick={() => handleAttachmentFileShow(value)}
          closable={closable}
          onClose={() => {
            onClose(), removeAttachment(value);
          }}
          className="attchment-selected"
          icon={
            <BoxIcons type={IconTypes.BOX_ICON} name={value.split(".").pop()} />
          }
        >
          {value}
        </$Tag>
      </$Tooltip>
    );
  };

  const uploadProps = {
    beforeUpload: (file: any) => {
      const isLtMax =
        file?.size / 1024 / 1024 > uploadRules.data[0]?.propertyValue;
      const allowedTypes = uploadRules.data[1]?.propertyValue
        .split(",")
        .map((type: string) => type.trim());
      if (isLtMax) {
        setFileStatus({
          status: "error",
          message: t("US.COLLECTION.CASE:NOTESANDMESSAGES.FILE_SIZE_EXCEEDED"),
        });
      } else if (!allowedTypes.contains(file.type)) {
        setFileStatus({
          status: "error",
          message: t("US.COLLECTION.CASE:NOTESANDMESSAGES.INVALID_FILE_FORMAT"),
        });
      }
      return false;
    },
    accept: uploadRules.data[1]?.propertyValue,
  };

  const handleUpload = (file: any, values:any) => {
    if (fileStatus?.status == "error") {
      $MessageBox("error", fileStatus?.message, "", "");
    } else {
      const formData = GetFileUploadRequest.call({
        caseId: metaData.data?.caseId,
        caseType: metaData.data?.entityType,
        storageType: StorageType.BLOB,
        file,
      });
      uploadingDocument && uploadingDocument({request: formData, formValues: values});
    }
  };

  /**
   * Get filtered content
   * @param eventData - event data
   * @param setValues - set formik values function
   * @param values - Formik values
   * @param criteria Document criteria 
   */
  const filterAttachments = (
    eventData: any,
    setValues: any,
    values: any,
    criteria: string
  ) => {
    let documentsOrderByDate = [];
    if (criteria == DocumentCriteria.PRINTED) {
      documentsOrderByDate = getModifiedPrintedDocuments(
        orderByCreatedDate(
          printedDocuments?.data,
          SortDocumentCriteria.EXECUTED_TIME
        )
      );
    } else {
      documentsOrderByDate = orderByCreatedDate(
        uploadedDocuments?.data,
        SortDocumentCriteria.UPLOADED_TIME
      );
    }
    const filteredDocuments = filterDocumentsByName(
      documentsOrderByDate,
      eventData,
      criteria == DocumentCriteria.PRINTED
        ? FilterDocumentCriteria.ACTIVITY_NAME
        : FilterDocumentCriteria.DOCUMENT_NAME
    );
    criteria == DocumentCriteria.PRINTED
      ? setValues({ ...values, printedDocuments: filteredDocuments })
      : setValues({ ...values, uploadedDocuments: filteredDocuments });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...domainMessageInitial
      }}
      validationSchema={EmailValidation}
      onSubmit={handleTemplateDrawer}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValidating,
        resetForm,
        setValues,
        ...rest
      }: any) => (
        <div className="py-3">
          <$Form>
            <$Row gutter={16} className="mt-0">
              <$Col
                span={10}
                xxl={{
                  span: 10,
                }}
                xl={{
                  span: 12,
                }}
              >
                <div
                  style={{
                    marginTop: 0,
                  }}
                  data-testid="document-type-label"
                >
                  {t("US.COLLECTION.CASE:NOTESANDMESSAGES.DOCUMENTTYPE")}
                </div>
              </$Col>
              <$Col
                span={14}
                xxl={{
                  span: 14,
                }}
                xl={{
                  span: 12,
                }}
                data-testid="select-document-type"
              >
                <$Select
                  name="documentType"
                  placeholder="Status"
                  size="small"
                  className="w-100"
                  data-testid="document-type"
                  allOption={false}
                  options={domainMessageInitial.documentTypeList}
                  onChange={(type: any) => changeDocumentType(type, rest)}
                  defaultValue={values.documentType}
                  disabled={
                    sendDomainMessage?.isProgress ||
                    (metaData.data && isSubCaseTransferredToCase(metaData.data))
                  }
                />
              </$Col>
            </$Row>

            <$Row gutter={16} className="mt-2">
              <$Col
                span={10}
                xxl={{
                  span: 10,
                }}
                xl={{
                  span: 12,
                }}
              >
                <div
                  style={{
                    marginTop: 5,
                  }}
                  data-testid="email-label"
                >
                  {t("US.COLLECTION.CASE:NOTESANDMESSAGES.EMAILADDRESS")}
                </div>
              </$Col>
              <$Col
                span={14}
                xxl={{
                  span: 14,
                }}
                xl={{
                  span: 12,
                }}
                data-testid="email-address"
              >
                <$Input
                  name="emailAddress"
                  size="small"
                  defaultValue={values.emailAddress?.trim()}
                  disabled={
                    sendDomainMessage?.isProgress ||
                    (metaData.data && isSubCaseTransferredToCase(metaData.data))
                  }
                />
              </$Col>
            </$Row>

            <$Row gutter={16} className="mt-1">
              <$Col
                span={10}
                xxl={{
                  span: 10,
                }}
                xl={{
                  span: 12,
                }}
              >
                <div
                  style={{
                    marginTop: 0,
                  }}
                  data-testid="attachment-label"
                >
                  {t("US.COLLECTION.CASE:NOTESANDMESSAGES.ATTACHMENT")}
                </div>
              </$Col>
              <$Col
                span={14}
                xxl={{
                  span: 14,
                }}
                xl={{
                  span: 12,
                }}
              >
                <div className="d-flex flex-column">
                  <div className="d-flex" data-testid="email-attachment">
                    <$Select
                      className="attchment flex-grow-1"
                      name="attachment"
                      mode="multiple"
                      placeholder={t(
                        "US.COLLECTION.CASE:NOTESANDMESSAGES.ADD_AN_ATTACHMENT"
                      )}
                      size="small"
                      allOption={false}
                      tagRender={tagRender}
                      value={selectAttachment?.fileNames}
                      options={values.attachmentOptions}
                      disabled={
                        sendDomainMessage?.isProgress ||
                        (metaData.data &&
                          isSubCaseTransferredToCase(metaData.data))
                      }
                      data-testid="select-attachments"
                    />
                    <$Button
                      disabled={sendDomainMessage?.isProgress}
                      type="default"
                      size="small"
                      onClick={()=>showDrawer(values)}
                      data-testid="add-attachment-button"
                    >
                      <FileAddOutlined />
                    </$Button>
                  </div>
                </div>
              </$Col>
            </$Row>

            <$Row gutter={16} className="mt-2">
              <$Col
                span={10}
                xxl={{
                  span: 10,
                }}
                xl={{
                  span: 12,
                }}
              >
                <div
                  style={{
                    marginTop: 5,
                  }}
                  data-testid="due-date-label"
                >
                  {t("US.COLLECTION.CASE:NOTESANDMESSAGES.MANUALDUEDATE")}
                </div>
              </$Col>
              <$Col
                span={14}
                xxl={{
                  span: 14,
                }}
                xl={{
                  span: 12,
                }}
              >
                <$DatePicker
                  formitem
                  formitemlabel={t(
                    "US.COLLECTION.CASE:NOTESANDMESSAGES.DUEDATE"
                  )}
                  className="w-100"
                  name="dueDate"
                  size="small"
                  placeholder={currentDateFormat}
                  format={currentDateFormat}
                  allowClear
                  value={values.dueDate}
                  defaultPickerValue={values.dueDate}
                  disabledDate={(day: any) =>
                    day.isBefore(dayjs().startOf("day"))
                  }
                  disabled={
                    sendDomainMessage?.isProgress ||
                    (metaData.data && isSubCaseTransferredToCase(metaData.data))
                  }
                  data-testid="manual-duedate"
                />
              </$Col>
            </$Row>

            <div className="d-flex align-items-center justify-content-between mt-3">
              <div>
                {sendDomainMessage?.isProgress && (
                  <small className="d-block">
                    <$Spin
                      size="small"
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: 20,
                          }}
                          spin
                        />
                      }
                    />
                    <span className="ml-2">
                      {t(
                        "US.COLLECTION.CASE:NOTESANDMESSAGES.SEND_EMAIL_IN_PROGRESS"
                      )}
                    </span>
                  </small>
                )}
              </div>
              <$Button
                type="default"
                htmlType="submit"
                onClick={handleSubmit}
                icon={<RightOutlined />}
                disabled={
                  (metaData.data &&
                    isSubCaseTransferredToCase(metaData.data)) ||
                  sendDomainMessage?.isProgress
                }
                data-testid="send-btn"
              >
                {t("US.COLLECTION.COMMON:COMMON.NEXT")}
              </$Button>
            </div>
            {openTemplateDrawer.visible && (
              <TemplateEditor
                closeTemplateDrawer={() => closeTemplateDrawer(rest)}
                openTemplateDrawer={openTemplateDrawer}
                domainMessageFormattedTemplate={domainMessageFormattedTemplate}
                domainMessageInitial={values}
                documentType={DomainMessageType.EMAIL}
                messageContentDetails={formattedMessageContentDetails}
                send={sendDashboardMessage}
                metaData={metaData}
                selectAttachment={selectAttachment}
                isValidationRequired={true}
              />
            )}
          </$Form>
          <$Drawer
            title={openTemplateDrawer.title}
            width="1280px"
            placement="right"
            onClose={closeDrawer}
            className="select-attchment-drawer"
            destroyOnClose
            open={
              openTemplateDrawer.isSelectAttachment &&
              openTemplateDrawer.visible
            }
            data-testid="attachment-drawer"
          >
            <$Skeleton
              active
              loading={
                uploadedDocuments?.isLoading || printedDocuments?.isLoading
              }
              className={
                uploadedDocuments?.isLoading || printedDocuments?.isLoading
                  ? "m-3"
                  : ""
              }
            >
              <div className="d-flex sad-container">
                <div className="sad-folders">
                  <p>
                    <strong>
                      {t("US.COLLECTION.CASE:NOTESANDMESSAGES.DOCUMENT_FOLDER")}
                    </strong>
                  </p>
                  <div
                    className={
                      isPrintedDoc
                        ? "d-flex align-items-start sad-folder-item sad-folder-item-selected"
                        : "d-flex align-items-start sad-folder-item"
                    }
                    onClick={() => {
                      setIsPrintedDoc(true);
                      setSelectAttachment((state) => ({
                        ...state,
                        isSelected: isPrintedDoc ? state.isSelected : false,
                      }));
                    }}
                  >
                    <span>
                      {isPrintedDoc ? <FolderOpenFilled /> : <FolderFilled />}
                    </span>
                    <span className="ml-2">
                      {t(
                        "US.COLLECTION.CASE:NOTESANDMESSAGES.PRINTED_DOCUMENTS"
                      )}
                    </span>
                  </div>
                  <div
                    className={
                      !isPrintedDoc
                        ? "d-flex align-items-start sad-folder-item sad-folder-item-selected"
                        : "d-flex align-items-start sad-folder-item"
                    }
                    onClick={() => {
                      setIsPrintedDoc(false);
                      setSelectAttachment((state) => ({
                        ...state,
                        isSelected: isPrintedDoc ? false : state.isSelected,
                      }));
                    }}
                  >
                    <span>
                      {isPrintedDoc ? <FolderFilled /> : <FolderOpenFilled />}
                    </span>
                    <span className="ml-2">
                      {t(
                        "US.COLLECTION.CASE:NOTESANDMESSAGES.UPLOADED_DOCUMENTS"
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  {/* Printed documents list */}
                  {isPrintedDoc && (
                    <>
                      <div className="sad-documents-header">
                        <$Input
                          placeholder={t(
                            "US.COLLECTION.CASE:NOTESANDMESSAGES.FILTER_ATTACHMENTS"
                          )}
                          name="filter"
                          size="small"
                          style={{ width: 285 }}
                          onChange={(event: any) => {
                            filterAttachments(
                              event?.target?.value,
                              setValues,
                              values,
                              DocumentCriteria.PRINTED
                            );
                          }}
                        />
                      </div>
                      {values?.printedDocuments?.length < 1 ? (
                        <div className="pt-5">
                          <$Empty
                            image={$Empty.PRESENTED_IMAGE_SIMPLE}
                            description={t("COMMON.NO_DATA")}
                          />
                        </div>
                      ) : (
                        <div
                          className={`sad-documents sad-documents-printed ${
                            selectAttachment?.isSelected
                              ? "sad-documents-with-footer"
                              : ""
                          }`}
                        >
                          <div
                            className="sad-documents-body"
                            data-testid="printed-documents"
                          >
                            <div className="sad-documents-wrap">
                              <PrintedDocuments
                                documents={getModifiedPrintedDocuments(
                                  orderByCreatedDate(
                                    values?.printedDocuments,
                                    SortDocumentCriteria.EXECUTED_TIME
                                  )
                                )}
                                handleAttachment={handleAttachment}
                              />
                            </div>
                          </div>
                          {selectAttachment?.isSelected && (
                            <div className="sad-documents-footer">
                              <$Alert
                                message={t(
                                  "US.COLLECTION.CASE:NOTESANDMESSAGES.FILE_ALREDY_SELECTED"
                                )}
                                type="error"
                                showIcon
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {/* Uploaded documents list */}
                  {!isPrintedDoc && (
                    <>
                      <div className="sad-documents-header">
                        <$Input
                          placeholder={t(
                            "US.COLLECTION.CASE:NOTESANDMESSAGES.FILTER_ATTACHMENTS"
                          )}
                          name="filter"
                          size="small"
                          style={{ width: 285 }}
                          onChange={(event: any) => {
                            filterAttachments(
                              event?.target?.value,
                              setValues,
                              values,
                              DocumentCriteria.UPLOADED
                            );
                          }}
                        />
                        <$Divider className="bui-devider" type="vertical" />
                        <$Upload
                          {...uploadProps}
                          showUploadList={false}
                          onChange={(info: any) => {
                            handleUpload(info?.file, values);
                          }}
                          maxCount={1}
                        >
                          <$Button
                            type="primary"
                            icon={<UploadOutlined />}
                            className="mr-3"
                            size="small"
                          >
                            {t(
                              "US.COLLECTION.CASE:NOTESANDMESSAGES.UPLOAD_NEW_DOCUMENT"
                            )}
                          </$Button>
                        </$Upload>
                        <$Tooltip
                          placement="topLeft"
                          title={
                            `${t(
                              "US.COLLECTION.DOCUMENTS:CASEDOCUMENTS.ONLY_ALLOWED"
                            )}${" "}` +
                            `${uploadRules.data[1]?.propertyValue}${" "}` +
                            `(${t(
                              "US.COLLECTION.DOCUMENTS:CASEDOCUMENTS.MAXIMUM_UPLOAD_SIZE"
                            )}${" "}` +
                            `${uploadRules.data[0]?.propertyValue}MB)`
                          }
                        >
                          <small className="sad-info">
                            {`${t(
                              "US.COLLECTION.DOCUMENTS:CASEDOCUMENTS.ONLY_ALLOWED"
                            )}${" "}` +
                              `${uploadRules.data[1]?.propertyValue}${" "}` +
                              `(${t(
                                "US.COLLECTION.DOCUMENTS:CASEDOCUMENTS.MAXIMUM_UPLOAD_SIZE"
                              )}${" "}` +
                              `${uploadRules.data[0]?.propertyValue}MB)`}
                          </small>
                        </$Tooltip>
                      </div>
                      {values?.uploadedDocuments?.length < 1 ? (
                        <div className="pt-5">
                          <$Empty
                            image={$Empty.PRESENTED_IMAGE_SIMPLE}
                            description="There are no uploaded documents here."
                          ></$Empty>
                        </div>
                      ) : (
                        <div
                          className={`sad-documents sad-documents-uploaded ${
                            selectAttachment?.isSelected
                              ? "sad-documents-with-footer"
                              : ""
                          }`}
                        >
                          <div
                            className="sad-documents-body"
                            data-testid="printed-documents"
                          >
                            <div className="sad-documents-wrap">
                              <UploadedDocuments
                                documents={ orderByCreatedDate(
                                  values?.uploadedDocuments,
                                  SortDocumentCriteria.UPLOADED_TIME
                                )}
                                handleAttachment={handleAttachment}
                                deleteDocument={deleteDocument}
                                values={values}
                              />
                            </div>
                          </div>
                          {selectAttachment?.isSelected && (
                            <div className="sad-documents-footer">
                              <$Alert
                                message={t(
                                  "US.COLLECTION.CASE:NOTESANDMESSAGES.FILE_ALREDY_SELECTED"
                                )}
                                type="error"
                                showIcon
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </$Skeleton>
          </$Drawer>
          <$Drawer
            title={openAttachmentDrawer?.title}
            width="900px"
            placement="left"
            onClose={closeAttachmentFileShow}
            className="case-doc-viwer case-doc-preview"
            open={openAttachmentDrawer?.visible}
            destroyOnClose
          >
            <$Skeleton loading={emailAttachmentContent?.isLoading}>
              {(!showAttachmentFile ||
                unableToDisplayFormats.includes(
                  showAttachmentFile?.documentType
                )) && (
                <div className="unable-to-display">
                  <$Empty
                    image={<FileExclamationOutlined />}
                    description={
                      <span>
                        {t(
                          "US.COLLECTION.DOCUMENTS:CASEDOCUMENTS.PREVIEW_IS_NOT_AVAILABLE"
                        )}
                      </span>
                    }
                  />
                </div>
              )}
              {!unableToDisplayFormats.includes(
                showAttachmentFile?.documentType
              ) &&
                showAttachmentFile?.documentType == "xml" && (
                  <XMLViewer
                    xml={base64toStr(showAttachmentFile?.content)}
                    theme={{
                      overflowBreak: true,
                    }}
                    indentSize={5}
                    collapsible={true}
                  />
                )}
              {!unableToDisplayFormats.includes(
                showAttachmentFile?.documentType
              ) &&
                showAttachmentFile?.documentType != "xml" && (
                  <div className="case-doc-viwer-inner">
                    <object
                      className={
                        showAttachmentFile?.documentType === "pdf"
                          ? "case-doc-frame frame-pdf"
                          : "case-doc-frame frame-html"
                      }
                      type={getMIMETypeByFileFormat(
                        showAttachmentFile?.documentType
                      )}
                      data={`data:${getMIMETypeByFileFormat(
                        showAttachmentFile?.documentType
                      )};base64,${showAttachmentFile?.content}`}
                    />
                  </div>
                )}
              <div className="drawer-footer-fixed align-content-center justify-content-end">
                <div>
                  <$Button onClick={() => closeAttachmentFileShow()}>
                    {t("US.COLLECTION.COMMON:COMMON.CANCEL")}
                  </$Button>
                </div>
              </div>
            </$Skeleton>
          </$Drawer>
        </div>
      )}
    </Formik>
  );
};

const mapState = (state: IRootState) => {
  const { common, domainView, messageAndNotes, router } = state;
  const { currentDateFormat } = common;
  const { location } = router;
  const { metaData } = domainView;
  const {
    domainMessageTemplate,
    domainMessageFormattedTemplate,
    openTemplateDrawer,
    domainMessageBasicdetail,
    domainMessageInitial,
    openAttachmentDrawer,
    printedDocuments,
    uploadedDocuments,
    emailAttachmentContent,
    sendDomainMessage,
    formattedMessageContentDetails,
    uploadRules,
  } = messageAndNotes;
  return {
    currentDateFormat,
    domainMessageTemplate,
    domainMessageFormattedTemplate,
    openTemplateDrawer,
    domainMessageBasicdetail,
    metaData,
    domainMessageInitial,
    openAttachmentDrawer,
    printedDocuments,
    uploadedDocuments,
    emailAttachmentContent,
    location,
    sendDomainMessage,
    formattedMessageContentDetails,
    uploadRules,
  };
};

const {
  formattedTemplate,
  emailAttachment,
  printedDocument,
  uploadDocument,
  emailAttachmentContent,
  domainMessage,
  messageContent,
  dashboardMessage,
  documentUploading,
  uploadRules,
  documentDeletion,
} = MessageAndNoteAction;

const mapDispatch = {
  getMessageContent: messageContent.get,
  openDrawer: formattedTemplate.openDrawer,
  reset: formattedTemplate.reset,
  send: domainMessage.save,
  showAttachment: emailAttachment.openDrawer,
  getPrintedDocument: printedDocument.get,
  getUploadedDocument: uploadDocument.get,
  getAttachmentContent: emailAttachmentContent.get,
  sendDashboardMessage: dashboardMessage.save,
  uploadingDocument: documentUploading.save,
  getUploadingRules: uploadRules.get,
  deleteDocument: documentDeletion.update,
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Email);
